import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import {
  IconBookmarkSolid,
  IconAlertsSolid,
  IconAudioSolid,
  IconChatSolid,
  IconEyeSolid,
  IconMicSolid,
  IconEmptySolid,
} from '@instructure/ui';
import { usePlayerStore, getStore } from '../../../../stores/StoreContext';
//import AnnotationPopover from './Popover';
import CONSTANTS from '../../../../config/constants';
const PointAnnotation = ({ annotation, type, row = 0, totalRows = 1, onMouseEnter, onMouseLeave }) => {
  const markerRef = useRef(null);
  const PlayerStore = getStore('playerStore');
  const ExamSessionStore = getStore('examSessionStore');
  const sessionDuration = usePlayerStore((state) => state.duration);
  const { setCurrentTime, onSeek } = usePlayerStore();
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const elementId = `annotation_${annotation.sid}`;
  const rowHeight = 9; // Same as RangeAnnotation

  const handleAnnotationClick = useCallback(() => {
    if (
      annotation.start > CONSTANTS.ANNOTATIONS.SECONDS_LEADING_TO_ANNOTATION
    ) {
      PlayerStore.jumpTo(
        annotation.start - CONSTANTS.ANNOTATIONS.SECONDS_LEADING_TO_ANNOTATION
      );
    } else {
      PlayerStore.jumpTo(0);
    }
  }, [annotation.start, PlayerStore]);

  const icon = useMemo(() => {
    //TODO: We will need to adjust this based on the final layout...
    return <IconEmptySolid style={{ fontSize: '10px' }} />
    //return type?.icon || <IconEmptySolid style={{ fontSize: '10px' }} />;
  }, [type?.icon]);

  const annotationStyle = useMemo(() => ({
    position: 'absolute',
    top: `${row * rowHeight}px`, // Apply vertical offset based on row
    left: `${(annotation.start / sessionDuration) * 100}%`,
    transform: 'translateX(-50%)',
    cursor: 'pointer',
    zIndex: 9999,
  }), [annotation.start, sessionDuration, row, rowHeight]);

  const handleContextMenu = useCallback(
    (e) => {
      e.preventDefault();
      const rect = document.getElementById(elementId).getBoundingClientRect();
      setContextMenuPosition({ top: rect.bottom, left: rect.left });
      setShowContextMenu(true);
      ExamSessionStore.setManagingAnnotation({ ...annotation });
    },
    [annotation, ExamSessionStore]
  );

  return (
    <>
      <div
        ref={markerRef}
        key={annotation.id}
        id={elementId}
        className="flag-point-marker"
        style={annotationStyle}
        onClick={handleAnnotationClick}
        onMouseEnter={(e) => onMouseEnter?.(e, annotation)}
        onMouseLeave={(e) => onMouseLeave?.(e)}
      //onContextMenu={handleContextMenu}
      >
        {icon}
      </div>
    </>
  );
};

export default React.memo(PointAnnotation);
